import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SettingModel } from '../models/classes/setting';
import { SchemaInfoModel } from '../models/classes/schema-info';

@Injectable({
  providedIn: 'root'
})

export class SettingsService {
  ip = environment.ipServer;
  private userUrl = `${this.ip}/api/Setting`;

  constructor(private http: HttpClient) { }

  addSettings(setting: SettingModel )
  {
    const url = `${this.userUrl}`;
    return this.http.post(url,setting,{ observe: 'response' }).pipe(
      tap(data => data)
    );
  }

  getSettings():Observable<SettingModel>{
    const url = `${this.userUrl}`;
    return this.http.get<SettingModel>(url).pipe(
      tap((data) => data));
  }

  exportSettings() {
    let url = `${this.userUrl}/ExportSettings`;
    return this.http.get(url).pipe(
      tap((data) => data));
  }

  importSettings(file) {
    let url = `${this.userUrl}/ImportSettings`;
    return this.http.post(url,file,{ observe: 'response' });
  }

  getSchemaInfo() {
    let url = `${this.ip}/api/SystemInfo/GetSchemaHealth`;
    return this.http.get<SchemaInfoModel[]>(url).pipe(
      tap((data) => data));
  }


  sendTestNotification(email: string): Observable<any> {
    const url = `${this.ip}/api/email/SendTestEmail/${email}`;
    return this.http.get(url,{ observe: 'response' });
  }
}
